module.exports = __webpack_public_path__ + "img/20.9ca922d7.jpg";